/**
 * Redirect URL validation utilities
 * Prevents open redirect attacks by validating redirect URLs are internal only
 */

// Allowed internal paths that can be redirected to
const ALLOWED_PATHS = [
  '/dashboard',
  '/systems',
  '/devices',
  '/rooms',
  '/settings',
  '/backups',
  '/bindings',
  '/verification',
  '/jailbreak',
  '/discovery',
]

/**
 * Validates that a redirect URL is safe (internal only)
 * Prevents open redirect attacks
 */
export function isValidRedirect(url: string | null): boolean {
  if (!url) return true // null/empty defaults to /dashboard

  // Must start with / (relative path)
  if (!url.startsWith('/')) return false

  // Prevent protocol redirects (javascript:, data:, etc)
  if (url.includes(':')) return false

  // Prevent double-slash which could be interpreted as protocol-relative URL
  if (url.startsWith('//')) return false

  // Must start with an allowed path
  return ALLOWED_PATHS.some((path) => url.startsWith(path))
}

/**
 * Get a safe redirect URL, defaulting to /dashboard if invalid
 */
export function getSafeRedirect(url: string | null): string {
  if (isValidRedirect(url) && url) {
    return url
  }
  return '/dashboard'
}
